import { styleColumn } from './StyleColumn/StyleColumn';

export const broadcastColumn = t => [
  {
    name: t("COMMON:FIELD.DATE_TIME"),
    selector: "created_at",
    sortable: true,
    width: "20vw",
    padding: styleColumn.paddingColumnStart,
  },
  {
    name: t("COMMON:FIELD.MAPPING_DATA_TYPE"),
    selector: "mapping_data_type",
    width: "25vw",
  },
  {
    name: t("COMMON:FIELD.ID"),
    selector: "id",
    width: "15vw",
  },
  {
    name: t("COMMON:FIELD.ADMIN"),
    selector: "created_by",
    width: "20vw",
    
    
  },
  {
    name: t("COMMON:FIELD.RESOURCE"),
    selector: "resource",
    width: "20vw",
    padding: styleColumn.paddingColumnEnd,
  },
];
